var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "static-page" },
    [
      _c("pages-wrapper", [
        _c("div", {
          staticClass: "static-page-content html-content",
          domProps: { innerHTML: _vm._s(_vm.PAGE_CONTENT) }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }